'use client'

import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

/** Cặp nút "Mua ngay" (cuộn tới listing) + "Khám phá BST khác" ở CTA cuối trang */
export const TheMartianActions = () => {
  const t = useTranslations('the_martian_hardcode.cta')

  return (
    <div className='grid w-full gap-4 lg:w-auto lg:auto-cols-max lg:grid-flow-col lg:gap-6'>
      <Button
        size='large'
        variant='white'
        className='h-[50px] px-10'
        onClick={() => {
          document.getElementById('collection-listing')?.scrollIntoView({
            behavior: 'smooth',
          })
        }}
      >
        {t('buy_now')}
        <ArrowRight className='!size-5' />
      </Button>
      <Button
        asChild
        size='large'
        variant='outline-white'
        className='h-[50px] bg-white/10 px-10'
      >
        <Link href='/highlight-collections'>
          {t('explore_more')}
          <ArrowRight className='!size-5' />
        </Link>
      </Button>
    </div>
  )
}
